import { AdvancedDetails, AvailabilityDetails, BasicDetails, FormValues } from './types';
import { Offer, OptionBinding } from '../../types';

export type OfferTab = keyof typeof offerTabs;

export const offerTabs = Object.freeze({
  DETAILS: 'DETAILS',
  ADVANCED: 'ADVANCED',
  AVAILABILITY: 'AVAILABILITY',
  OPTIONS: 'OPTIONS',
} as const);

export type AllTabsFields = keyof (BasicDetails & AdvancedDetails & AvailabilityDetails & OptionBinding);

export const detailsTabFields: Record<keyof BasicDetails, string> = {
  categoryId: 'categoryId',
  brandId: 'brandId',
  name: 'name',
  productHierarchyLevelId: 'productHierarchyLevelId',
  description: 'description',
  price: 'price',
  discountType: 'discountType',
  fixedDiscountPrice: 'fixedDiscountPrice',
  discountPercentage: 'discountPercentage',
  weightInGrams: 'weightInGrams',
  volumeInMl: 'volumeInMl',
  numberOfUnits: 'numberOfUnits',
  displayUnit: 'displayUnit',
  vat: 'vat',
  alcoholPercentage: 'alcoholPercentage',
  caffeineContentValue: 'caffeineContentValue',
  caffeineContentUnits: 'caffeineContentUnits',
  posId: 'posId',
  barcodeGtin: 'barcodeGtin',
  merchantSku: 'merchantSku',
  source: 'source',
  sourceConfig: 'sourceConfig',
  image: 'image',
  weightType: 'weightType',
  sellByWeightInputType: 'sellByWeightInputType',
  gramsPerStep: 'gramsPerStep',
  productId: 'productId',
  eatinCommission: 'eatinCommission',
  homedeliveryCommission: 'homedeliveryCommission',
  takeawayCommission: 'takeawayCommission',
};

export const advancedTabFields: Record<keyof AdvancedDetails, string> = {
  dietaryPreferences: 'dietaryPreferences',
  ingredients: 'ingredients',
  additives: 'additives',
  allergens: 'allergens',
  moreInformation: 'moreInformation',
  nutritionFacts: 'nutritionFacts',
  nutritionValues: 'nutritionValues',
  nutritionValuesBaseline: 'nutritionValuesBaseline',
  countryOfOrigin: 'countryOfOrigin',
  usageInstructions: 'usageInstructions',
  producerInfo: 'producerInfo',
  distributorInfo: 'distributorInfo',
  bundleOffer: 'bundleOffer',
  depositOption: 'depositOption',
  mandatoryWarnings: 'mandatoryWarnings',
  externalInfoHyperlink: 'externalInfoHyperlink',
};

export const availabilityTabFields: Record<keyof AvailabilityDetails, string> = {
  enabled: 'enabled',
  availabilityPeriod: 'availabilityPeriod',
  useWeeklyAvailability: 'useWeeklyAvailability',
  weeklyAvailability: 'weeklyAvailability',
  useWeeklyVisibility: 'useWeeklyVisibility',
  weeklyVisibility: 'weeklyVisibility',
  userRequirement: 'userRequirement',
  maxQuantityPerPurchase: 'maxQuantityPerPurchase',
  minQuantityPerPurchase: 'minQuantityPerPurchase',
  enableEatin: 'enableEatin',
  enableTakeaway: 'enableTakeaway',
  enableDelivery: 'enableDelivery',
  disableBikeDelivery: 'disableBikeDelivery',
  disableCarDelivery: 'disableCarDelivery',
  disableMotorcycleDelivery: 'disableMotorcycleDelivery',
  isRestrictedItem: 'isRestrictedItem',
  isWoltPlusOnly: 'isWoltPlusOnly',
  isOTCRestricted: 'isOTCRestricted',
  isAgeRestricted: 'isAgeRestricted',
  ageLimit: 'ageLimit',
  isDeliveryHandshakeRestricted: 'isDeliveryHandshakeRestricted',
};

export const overrideFormFieldToOfferAttrMap: Partial<Record<keyof FormValues, (keyof Offer)[]>> = {
  priceOverride: ['price'],
  discountPercentageOverride: ['discounted', 'price'],
  discountTypeOverride: ['discounted', 'price'],
  fixedDiscountPriceOverride: ['discounted', 'price'],
  enabledOverride: ['enabled'],
  availabilityPeriodOverride: ['enabled'],
  posIdOverride: ['external_id'],
  merchantSkuOverride: ['merchant_sku'],
  weeklyAvailabilityOverride: ['weekly_availability'],
  useWeeklyAvailabilityOverride: ['weekly_availability'],
  weeklyVisibilityOverride: ['weekly_visibility'],
  useWeeklyVisibilityOverride: ['weekly_visibility'],
};

export const NAME_MAX_LENGTH = 80;
export const DESCRIPTION_MAX_LENGTH = 2000;
